import { observer } from 'mobx-react-lite'
import type { IWidgetProps } from 'widgets/FilterEditor/types/types'
import { useFilterEditorContext } from 'widgets/FilterEditor/context/filterEditorContext'
import { WidgetHubspotMulti } from 'widgets/FilterEditor/ui/Widget/WidgetHubspot/ui/WidgetHubspotMulti/WidgetHubspotMulti'
import { WidgetHubspotSingle } from './WidgetHubspotSingle/WidgetHubspotSingle'

export const WidgetHubspot = observer((props: IWidgetProps) => {
  const { useWidgetHubspotMulti } = useFilterEditorContext()

  if (useWidgetHubspotMulti) return <WidgetHubspotMulti {...props} />

  return <WidgetHubspotSingle {...props} />
})
